import type { Ref } from 'vue';
import { computed } from 'vue';
import { useJersey } from '@/composable/useJersey';
import type { IStreamEvent } from '@/interface/IStream';
import { SportType } from '@/interface/enum';

export function useLiveStreamJerseyVisibility(selectedStreamEvent: Ref<IStreamEvent | null>) {
    const { isJerseyVisible } = useJersey();

    const isShowJersey = computed(() => {
        const event = selectedStreamEvent.value;

        if (!event || event.sportType === SportType.Cricket) {
            return false;
        }

        return isJerseyVisible(
            event.eventCode,
            event.sportType,
            event.league.size,
        );
    });

    return { isShowJersey };
}
